import { useStoreActions, useStoreState } from "easy-peasy";
import React, { useState } from "react";
import "./PopupCity.scss";
import Fade from "@material-ui/core/Fade";
const mainClass = "popupCity";

const sortCity = (arr) => {
  return arr.sort(function (a, b) {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  });
};

const PopupCity = () => {
  const setShowPopup = useStoreActions(
    (actions) => actions.cityIp.setShowPopup
  );
  const showPopup = useStoreState((state) => state.cityIp.showPopup);
  const getCityByCoordinates = useStoreActions(
    (actions) => actions.cityIp.getCityByCoordinates
  );
  const setCity = useStoreActions((actions) => actions.cityIp.setCity);
  const city = useStoreState((state) => state.cityIp.city);
  const citiesStore = useStoreState((state) => state.rent.cities);
  const [cities, setCities] = useState(
    sortCity(citiesStore.map((el) => el.title))
  );
  const [search, setSearch] = useState("");
  const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };

  async function success(pos) {
    const crd = pos.coords;
    await getCityByCoordinates(`${crd.latitude}&${crd.longitude}`);
    console.log("Ваше текущее местоположение:");
    console.log(`Широта: ${crd.latitude}`);
    console.log(`Долгота: ${crd.longitude}`);
    console.log(`Плюс-минус ${crd.accuracy} метров.`);
    setShowPopup(false);
  }

  function error(err) {
    console.warn(`ERROR(${err.code}): ${err.message}`);
    setShowPopup(false);
  }

  const getGeoPosition = async () => {
    navigator.geolocation.getCurrentPosition(success, error, options);
  };

  const handleSearch = (ev) => {
    if (ev.target.value != "") {
      setCities(
        sortCity(
          citiesStore
            .map((el) => el.title)
            .filter((el) =>
              el.toLowerCase().includes(ev.target.value.toLowerCase())
            )
        )
      );
    } else {
      setCities(sortCity(citiesStore.map((el) => el.title)));
    }
    setSearch(ev.target.value);
  };

  return (
    <Fade in={showPopup != false} timeout={500}>
      <div>
        <div className={mainClass} onClick={() => setShowPopup(false)}></div>
        <div className={mainClass + "-window"}>
          <span
            className="material-icons close"
            onClick={() => setShowPopup(false)}
          >
            close
          </span>
          <div className={mainClass + "-title"}>Выберите город, район</div>
          <div className={mainClass + "-search"}>
            <div className={mainClass + "-inputContainer"}>
              <input
                type="text"
                name="citySearch"
                value={search}
                onChange={handleSearch}
              ></input>
              <label htmlFor="citySearch" className="labelForInput">
                <span className="material-icons searchIcon">search</span>
                Введите название
              </label>
            </div>
            <div
              className={mainClass + "-btn btn red"}
              onClick={getGeoPosition}
            >
              <span className="title">определить</span>
              <span className="material-icons navigation">near_me</span>
            </div>
          </div>
          <div className={mainClass + "-cityContainer"}>
            {cities.map((el, index) => (
              <div
                key={index}
                className={mainClass + "-city"}
                onClick={() => {
                  setCity(el);
                  setShowPopup(false);
                }}
                style={{
                  textDecoration: city == el ? "underline" : "none",
                  color: city == el ? "#447f3f" : "black",
                }}
              >
                {el}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default PopupCity;
